import { createUseStyles } from 'react-jss'

export default createUseStyles(theme => ({
  spacer: {
    height: '118px',
    '@media (max-width: 1279px)': {
      height: '94px',
    },
  },
  header: {
    position: 'fixed',
    width: '100%',
    left: 0,
    top: 0,
    zIndex: 9999,
    backgroundColor: '#fff',
    borderBottom: '1px solid #ddd',
  },
  headerMini: {
    display: 'block',
    '@media (max-width: 1280)': {
      display: 'none',
    },

    backgroundColor: theme.colors.eggshell,

    '& a': {
      backgroundColor: ' transparent',
      color: theme.colors.warmGrey,
      display: 'inline-block',
      fontSize: 13,
      fontWeight: 'bold',
      letterSpacing: 1,
      lineHeight: '15px',
      padding: '8px 25px',
      textDecoration: 'none',
      transition: `background-color 250ms ${theme.animations.bezier}, color 250ms ${theme.animations.bezier}`,

      '&.tel': {
        color: theme.colors.deepsea,
      },

      '&:hover': {
        backgroundColor: theme.colors.silver,
        color: theme.colors.coal,
      },
    },
  },
  headerMiniInner: {
    ...theme.wrappers.standard,
    textAlign: 'right',
    '& > a:last-child': {
      marginRight: -25,
    },
  },
  headerMainInner: {
    ...theme.wrappers.standard,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    minHeight: '110px',
    '@media (max-width: 1279px)': {
      minHeight: '0',
    },
  },
  headerLogo: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      height: '79px',
      maxWidth: 129,
      width: '100%',
    },
  },
  headerNav: {
    marginLeft: 'clamp(26px, 3vw, 54px)',
    '@media (max-width: 1279px)': {
      display: 'none',
    },
  },
  mobileTrigger: {
    display: 'none',
    cursor: 'pointer',
    padding: '2em 0 2em 1em',
    justifyContent: 'flex-end',
    '@media (max-width: 1279px)': {
      display: 'flex',
    },
  },
  mobileLogin: {
    display: 'none',
    cursor: 'pointer',
    padding: '2em 0',
    marginLeft: 'auto',
    '@media (max-width: 1279px)': {
      display: 'flex',
    },
  },
  headerNavItems: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,

    '& li:first-child': {
      marginLeft: 0,
    },
  },
  headerNavItem: {
    float: 'left',
    margin: 0,
    padding: 0,
    marginLeft: 'max(20px, 2vw)',
    height: 110,
    display: 'flex',
    alignItems: 'center',
    '& .hoverMenu': {
      display: 'none',
    },
    '@media (min-width: 1280px)': {
      '&': {
        '&.is-active .hoverMenu, &:hover .hoverMenu': {
          width: '100%',
          zIndex: 3,
          backgroundColor: '#01588b',
          boxSizing: 'border-box',
          display: 'flex',
          position: 'absolute',
          top: 118,
          left: 0,
          paddingTop: 20,
          paddingBottom: 20,
          borderTop: '1px solid #ddd',
          '& .hoverMenuLinks': {
            boxSizing: 'border-box',
            width: '100%',
            maxWidth: 1490,
            paddingLeft: 230,
            margin: '0 auto',
            display: 'flex',
          },
          '& ul': {
            listStyle: 'none',
            boxSizing: 'border-box',
            padding: 0,
            marginRight: 0,
            width: 'auto',
            '& li': {
              marginBottom: 0,
              marginRight: 20,
              display: 'inline-block',
              '&:last-child': {
                marginBottom: 0,
                marginRight: 0,
              },
              '& a': {
                fontWeight: 500,
                fontSize: 16,
                lineHeight: 1.5,
                letterSpacing: '0.02em',
                textDecoration: 'none',
                color: '#fff',
                fontWeight: 500,
                display: 'inline-block',
                marginRight: 20,
                '&:hover, &.activeMenuLink': {
                  textDecoration: 'underline',
                },
                '&:last-child': {
                  marginRight: 0,
                },
              },
            },
          },
        },
      },
    },
  },
  headerNavItemRight: {
    float: 'left',
    margin: 0,
    padding: 0,
    marginLeft: 30,
  },
  headerNavOtherLinksMobile: {
    margin: '0 0 15px 0',
    display: 'block',
    color: '#2D2D2D',
    textDecoration: 'none',
    '&:first-child': {
      marginTop: '30px',
    },
  },
  headerNavOtherLinks: {
    marginRight: 30,
    display: 'inline-block',
    color: theme.colors.coal,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  headerNavLink: {
    color: theme.colors.coal,

    display: 'block',
    textAlign: 'center',
    padding: '6px 0 6px',
    textDecoration: 'none',
    borderBottom: '6px solid #fff',
    fontSize: 16,
    lineHeight: '19px',
    fontWeight: 500,
    transition: `border-bottom 250ms ${theme.animations.bezier}`,
    '&.is-active, &:hover': {
      borderBottom: `5px solid ${theme.colors.blue}`,
    },
  },
  headerNavLinkBooking: {
    borderRadius: theme.buttonBorderRadius,
    backgroundColor: theme.colors.main,
    color: theme.colors.white,
    fontSize: '15px',
    fontWeight: 700,
    letterSpacing: '0.1px',
    lineHeight: 'normal',
    textAlign: 'center',
    display: 'inline-block',
    paddingRight: 40,
    paddingLeft: 40,
    paddingTop: 10,
    paddingBottom: 10,
    textDecoration: 'none',
    marginTop: 30,
    transition: `background-color 250ms ${theme.animations.bezier}`,
    '@media (max-width: 1279px)': {
      marginTop: 0,
      paddingRight: 20,
      paddingLeft: 20,
    },
    '&:hover': {
      backgroundColor: theme.colors.mainHover,
      borderBottom: 'transparent',
    },
  },
  mobileNav: {
    display: 'none',
    position: 'fixed',
    top: 90,
    left: 0,
    width: '100%',
    zIndex: 500,
    height: 'calc(100vh - 90px)',
    background: 'white',
    boxSizing: 'border-box',
    borderTop: '1px solid #CCCCCC',
    '@media (min-width: 1280px)': {
      display: 'none !important',
    },
  },
  mobileNavActive: {
    display: 'flex',
  },
  mobileNavInner: {
    boxSizing: 'border-box',
    margin: '0 auto',
    padding: '0 30px 30px 30px',
    opacity: 1,
    height: '100%',
    width: '100%',
  },
  mobileHeaderMini: {
    boxSizing: 'border-box',
    marginBottom: 25,
    marginTop: '0',
    marginLeft: 'auto',
    marginRight: 'auto',
    '& .tel': {
      display: 'none',
    },
    '@media (max-width: 1279px)': {
      '& a:last-child': {
        backgroundColor: theme.colors.deepsea,
      },
    },
  },
  mobileHeaderMiniButtons: {
    marginRight: 15,
    backgroundColor: theme.colors.blue,
    borderRadius: theme.borderRadius,
    color: theme.colors.white,
    display: 'inline-block',
    fontSize: 14,
    fontWeight: 'bold',
    padding: '5px 10px',
    textDecoration: 'none',
    transition: `background-color 250ms ${theme.animations.bezier}`,

    '&:hover': {
      backgroundColor: theme.colors.deepsea,
    },
  },
  mobileNavItems: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    '& .is-closed': {
      display: 'none',
    },
  },
  mobileHeaderNavLink: {
    color: '#000000',
    cursor: 'pointer',
    display: 'inline-block',
    fontSize: 20,
    fontWeight: 700,
    lineHeight: '28px',
    marginTop: 30,
    position: 'relative',
    textDecoration: 'none',
    transition: `border-left 250ms ${theme.animations.bezier}`,
    width: '100%',
  },
  mobileNavBooking: {
    marginTop: 20,
  },
  mobileNavContact: {
    marginTop: 30,
  },
  headerNavWrapper: {
    display: 'block',
    '@media (max-width: 1279px)': {
      display: 'none',
    },
  },
  sitelogo: {
    '& img': {
      width: 152,
      height: 55,
      '@media (max-width: 1300px)': {
        width: 'auto',
        height: 43,
      },
      '@media (max-width: 992px)': {
        width: 'auto',
        height: 33,
      },
    },
  },
  icon: {
    marginLeft: 'auto',
    '& svg': {
      transform: 'rotate(90deg)',
      transition: `transform 250ms ${theme.animations.bezier}`,
    },
  },
  iconActive: {
    marginLeft: 'auto',
    '& svg': {
      transform: 'rotate(-90deg)',
      transition: `transform 250ms ${theme.animations.bezier}`,
    },
  },
  toggleBtn: {
    backgroundColor: '#F0F0F0',
    boxShadow: '0px 2px 2px 1px rgba(0, 0, 0, 0.12)',
    borderRadius: '50%',
    width: '24px',
    height: '22px',
    paddingTop: '2px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 20,
    '& svg': {
      transform: 'rotate(90deg)',
      transition: `transform ${theme.animations.animate}`,
    },
    '&.is-active': {
      '& svg': {
        transform: 'rotate(-90deg)',
        transition: `transform 250ms ${theme.animations.bezier}`,
      },
    },
  },
  alertBarText: {
    fontSize: '16px',
    fontWeight: '300',
    '& a': {
      color: '#000',
      textDecoration: 'underline',
    },
  },
}))
